/* TXR POWER — product page behaviours */
(function () {
  'use strict';

  /* Gallery — smooth crossfade swaps ---------------------------------------- */
  const galleryEl = document.querySelector('[data-product-gallery]');
  const mainImg = galleryEl ? galleryEl.querySelector('[data-gallery-main] img') : null;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FADE_MS = reduceMotion ? 0 : 200;
  let defaultSrc = null;
  let defaultSrcset = null;
  let swapToken = 0;

  if (mainImg) {
    if (!reduceMotion) mainImg.style.transition = 'opacity 0.2s ease';
    const firstThumb = galleryEl.querySelector('[data-thumb]');
    defaultSrc = firstThumb ? firstThumb.dataset.fullSrc : (mainImg.currentSrc || mainImg.src);
    defaultSrcset = firstThumb ? (firstThumb.dataset.fullSrcset || null) : mainImg.getAttribute('srcset');
  }

  function pathOf(url) {
    try { return new URL(url, window.location.origin).pathname; } catch (_) { return url; }
  }

  function syncThumbs(src) {
    if (!galleryEl || !src) return;
    const target = pathOf(src);
    galleryEl.querySelectorAll('[data-thumb]').forEach((t) => {
      t.classList.toggle('is-active', pathOf(t.dataset.fullSrc || '') === target);
    });
  }

  /* Preload the new image, then fade out → swap → fade in. No flash, no jump. */
  function swapMainImage(src, srcset) {
    if (!mainImg || !src) return;
    syncThumbs(src);
    if (pathOf(mainImg.src) === pathOf(src)) return;
    const token = ++swapToken;
    const pre = new Image();
    pre.onload = () => {
      if (token !== swapToken) return;
      mainImg.style.opacity = '0';
      setTimeout(() => {
        if (token !== swapToken) return;
        if (srcset) mainImg.setAttribute('srcset', srcset); else mainImg.removeAttribute('srcset');
        mainImg.src = src;
        requestAnimationFrame(() => { mainImg.style.opacity = '1'; });
      }, FADE_MS);
    };
    pre.src = src;
  }

  /* Variant picker --------------------------------------------------------- */
  document.querySelectorAll('[data-variant-picker]').forEach((root) => {
    const dataEl = root.querySelector('script[type="application/json"][data-variants]');
    if (!dataEl) return;
    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (_) { return; }
    const inputs = root.querySelectorAll('input[name^="options"]');
    const idInput = root.querySelector('input[name="id"]');
    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-product-compare]');
    const addBtn = document.querySelector('[data-add-to-cart]');
    const addBtnText = addBtn ? addBtn.querySelector('[data-add-to-cart-text]') : null;
    const stockEl = document.querySelector('[data-product-stock]');

    function selectedOptions() { const groups = {}; inputs.forEach((i) => { if (i.checked) groups[i.name] = i.value; }); return Object.values(groups); }
    function matchVariant() { const sel = selectedOptions(); return variants.find((v) => v.options.every((opt, i) => opt === sel[i])); }
    function syncSelectedClasses() { root.querySelectorAll('.variant-option__value').forEach((label) => { const input = label.querySelector('input'); label.classList.toggle('is-selected', !!input && input.checked); }); }
    function format(money) { if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(money, window.Shopify.money_format); return '£' + (money / 100).toFixed(2); }

    function update() {
      syncSelectedClasses();
      const v = matchVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = format(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = format(v.compare_at_price); compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        // Only update the inner text span — don't blow away the icon SVG sibling.
        if (addBtnText) {
          const labelAvail = addBtn.dataset.labelAvailable || addBtnText.textContent || 'Add to cart';
          const labelSold  = addBtn.dataset.labelSoldout   || 'Sold out';
          addBtnText.textContent = v.available ? labelAvail : labelSold;
        }
      }
      if (stockEl) stockEl.textContent = v.available ? (stockEl.dataset.inStock || 'In stock') : (stockEl.dataset.outStock || 'Out of stock');
      /* Swap the gallery image to match the selected variant (fall back to the
         product's featured image when the variant has no image of its own). */
      if (v.featured_image) { swapMainImage(v.featured_image, v.featured_srcset || null); }
      else { swapMainImage(defaultSrc, defaultSrcset); }
      if ('URLSearchParams' in window) { const url = new URL(window.location); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url); }
    }
    inputs.forEach((i) => i.addEventListener('change', update));
    update();
  });

  /* Quantity stepper ------------------------------------------------------- */
  document.querySelectorAll('.qty').forEach((qty) => {
    const input = qty.querySelector('input');
    qty.querySelector('[data-qty-down]')?.addEventListener('click', () => { input.value = Math.max(1, parseInt(input.value || '1', 10) - 1); });
    qty.querySelector('[data-qty-up]')?.addEventListener('click', () => { input.value = Math.max(1, parseInt(input.value || '1', 10) + 1); });
  });

  /* Gallery — thumb clicks swap main (same crossfade) ------------------------ */
  if (galleryEl) {
    galleryEl.querySelectorAll('[data-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        swapMainImage(thumb.dataset.fullSrc, thumb.dataset.fullSrcset || null);
      });
    });
  }

  /* Sticky ATC visibility -------------------------------------------------- */
  const stickyAtc = document.querySelector('.sticky-atc');
  const buyBox = document.querySelector('[data-buy-box]');
  if (stickyAtc && buyBox && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => { entries.forEach((e) => { stickyAtc.classList.toggle('is-visible', !e.isIntersecting); }); }, { rootMargin: '0px' });
    io.observe(buyBox);
  }

  document.querySelectorAll('[data-sticky-atc-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const data = new FormData(form);
      try { const res = await fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } }); if (res.ok) { window.location.href = '/cart'; } }
      catch (_) { form.submit(); }
    });
  });
})();
